/**
 * BFX CA language selector — wires each [data-bfx-language-selector] instance to
 * Impulse's theme.Disclosure (toggle opens the locale list; picking an option submits
 * the localization form). The snippet renders in the header and the drawer, so there can
 * be more than one instance — Impulse's own header init only binds a single one.
 */
const initBfxLanguageSelector = () => {
  const SELECTOR = '[data-bfx-language-selector]';
  // el -> Disclosure instance, so we can destroy on section unload (each Disclosure
  // attaches a document.body click listener that leaks otherwise).
  const instances = new Map();

  // Current path (with query + hash) with the active locale prefix stripped, so Shopify
  // re-applies the TARGET locale's prefix on switch. Shopify's auto return_to keeps the
  // current prefix (e.g. /fr-ca), which would land a fr->en switch back on the French URL.
  // Derive the prefix from the real locale (Shopify.locale = 'fr-CA') rather than
  // Shopify.routes.root, which reports '/fr' here and mismatches the '/fr-ca' subfolder.
  const delocalizedPath = () => {
    const { pathname, search, hash } = window.location;
    let path = pathname;
    const locale = (
      window.Shopify && window.Shopify.locale ? window.Shopify.locale : ''
    ).toLowerCase();
    if (locale && locale !== 'en') {
      const prefix = `/${locale}`;
      const lower = path.toLowerCase();
      // Only strip a full path segment — `/fr-ca` exactly or `/fr-ca/...` — so a handle
      // that merely starts with the locale (e.g. `/fr-ca-special`) isn't mangled.
      if (lower === prefix || lower.indexOf(`${prefix}/`) === 0) {
        path = path.slice(prefix.length) || '/';
      }
    }
    return path + search + hash;
  };

  const init = (root = document) => {
    if (!window.theme || !window.theme.Disclosure) return;

    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (instances.has(el)) return;
      instances.set(el, new window.theme.Disclosure(el));

      const form = el.closest('[data-disclosure-form]');
      const returnTo = form && form.querySelector('input[name="return_to"]');
      if (returnTo) returnTo.value = delocalizedPath();
    });
  };

  const destroy = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      const disclosure = instances.get(el);
      if (disclosure && typeof disclosure.destroy === 'function') disclosure.destroy();
      instances.delete(el);
    });
  };

  init();

  // Re-init / tear down instances as the theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBfxLanguageSelector);
} else {
  initBfxLanguageSelector();
}
